import { Currency, findCurrencies } from '~/Api/Currency';
import { invokeApi } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchCurrencies(): ThunkAction<Promise<Currency | null>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findCurrencies));
		dispatch({ type: ActionTypes.request, request });

		try {
			const response = await request;
			dispatch({
				type: ActionTypes.receive,
				request,
				currencies: response.items,
			});
			return response.items;
		} catch (error) {
			dispatch({ type: ActionTypes.receive, request, currencies: null });
			dispatch(handleError(error));
		}
		return null;
	};
}

export function fetchCurrenciesIfNeeded(): ThunkAction<Promise<Currency[] | null>, any> {
	return async (dispatch, getState) => {
		const { request } = getState().currency;
		if (request) {
			const response = await request;
			return response ? response.items : null;
		}
		return dispatch(fetchCurrencies());
	};
}
